import { Parser } from "@siteimprove/alfa-parser";
import {} from "../../../syntax/index.js";
import * as item from "./item/index.js";
import * as linear from "./linear/index.js";
import * as radial from "./radial/index.js";
const { either } = Parser;
/**
 * @public
 */
export var Gradient;
(function (Gradient) {
    Gradient.Item = item.Item;
    Gradient.Linear = linear.Linear;
    Gradient.Radial = radial.Radial;
    /**
     * {@link https://drafts.csswg.org/css-images/#typedef-gradient}
     */
    Gradient.parse = either(Gradient.Linear.parse, Gradient.Radial.parse);
})(Gradient || (Gradient = {}));
//# sourceMappingURL=gradient.js.map